import SourceFlowForm from '@sourceflow-uk/sourceflowform';
import { Container, Row, Col } from 'reactstrap';
import { useRouter } from "next/router";
import styles from './styles.module.scss';

export const ColumnWithForm = ({
    className,
    content,
    form,
    successPageUrl,
    divider,
}) => {

    if (!form) {
        return null;
    }

    const locale = useRouter().asPath.startsWith("/us/") ? "/us/" : "/";

    return (
        <section id="form" className={`${styles.root} ${className}`}>
            <span className="overlayBg position-absolute">
                <img src={"/site-assets/svg/branded-logo.svg"} alt="Branded Logo" />
            </span>
            <Container className="position-relative py-4 py-md-5">
                {divider &&
                    <hr className="pt-5" />
                }
                <Row>
                    <Col md={6} className="pe-md-5 mb-4 mb-md-0">
                        {content &&
                            <div dangerouslySetInnerHTML={{ __html: content }} />
                        }
                    </Col>
                    <Col md={6} className="ps-md-5">
                        <SourceFlowForm
                            formId={form}
                            onSubmitDone={() => (window.location.href = `${locale}${successPageUrl}`)}
                        />
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default ColumnWithForm;
